import Empty from '@/views/Empty';
import PrestartList from '@/views/pages/question_prestart/List';
import PrestartDetail from '@/views/pages/question_prestart/Detail';
import PrestartDetailIndex from '@/views/pages/question_prestart/detail/Index';
import PrestartQuestions from '@/views/pages/question_prestart/detail/Questions';

export default {
  path: 'question_prestart',
  component: Empty,
  meta: {
    accessKey: 'MAIN.PRESTART_CHECKLIST.READ',
  },
  children: [
    {
      path: '',
      name: 'Prestart List',
      component: PrestartList,
    },
    {
      path: ':answerSetId',
      component: PrestartDetail,
      children: [
        {
          path: '',
          name: 'Prestart Detail',
          component: PrestartDetailIndex,
        },
        {
          path: 'questions',
          name: 'Prestart Questions',
          component: PrestartQuestions,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/question_prestart.js